<div class="comment-viewer-container">
    <div class="comment-viewer-toolbar">
        @if (ViewCommentHistoryRight) {
            <mat-slide-toggle class="accent-button" [(ngModel)]="commentHistoryVisible" labelPosition="after">Afficher l'historique</mat-slide-toggle>
        }
    </div>
    @for (comment of sortedComments; track comment.id) {
        <div class="comment-viewer-content">
            @if (commentHistoryVisible || comment.state === CommentState.Created || comment.state === CommentState.Deleted) {
                <div class="comment-container">
                    <div class="comment-header">
                        <p class="comment-user">Commentaire de {{ comment.user }}</p>
                        @switch (comment.state) {
                            @case (CommentState.Updated) {
                                <p class="comment-state mode-history">(modifié)</p>
                            }
                            @case (CommentState.Deleted) {
                                <p class="comment-state mode-history">(Supprimé)</p>
                            }
                            @case (CommentState.Created) {
                                @if (comment.iteration > 1) {
                                    <p class="comment-state">(Modifié)</p>
                                }
                            }
                        }

                        <p class="comment-date">Le {{ comment.date | AvmDateAndTime }}</p>
                    </div>
                    <div class="comment-content">
                        @if (commentHistoryVisible || comment.state !== CommentState.Deleted) {
                            <div
                                class="comment-text"
                                [ngClass]="{ 'comment-deleted': comment.state === CommentState.Deleted, 'comment-updated': comment.state === CommentState.Updated }"
                                [innerHtml]="comment.safeText"></div>
                        }
                        @if (commentType === DocumentType.Comment) {
                            <div class="comment-actions">
                                @if (!readonly && UpdateCommentRight && comment.ownedByCurrentUser === true && comment.state === CommentState.Created) {
                                    <button mat-mini-fab class="basic-button" aria-label="Modifier le commentaire" (click)="onEditComment(comment)">
                                        <fa-icon [icon]="faPen"></fa-icon>
                                    </button>
                                }
                                @if (!readonly && DeleteCommentRight && comment.ownedByCurrentUser === true && comment.state === CommentState.Created) {
                                    <button mat-mini-fab class="basic-button" aria-label="Supprimer le commentaire" (click)="onDeleteComment(comment)">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>
